import { useMemo } from 'react'
import { useLocation } from 'react-router'

import { stripLocaleFromPath } from './utils'


/**
 * Hook that returns the current pathname without the locale prefix
 * Useful for parsing slugs from URLs
 * 
 * @example
 * // URL: /ru/catalog/cat1/cat2
 * const pathname = useStrippedPathname()
 * // pathname = '/catalog/cat1/cat2'
 */
export function useStrippedPathname (): string {
  const location = useLocation()
  
  return useMemo(
    () => stripLocaleFromPath(location.pathname),
    [ location.pathname ],
  )
}

/**
 * Hook that returns the current pathname segments without the locale
 * 
 * @example
 * // URL: /ru/catalog/cat1/cat2
 * const segments = usePathSegments()
 * // segments = ['catalog', 'cat1', 'cat2']
 */
export function usePathSegments (): string[] {
  const pathname = useStrippedPathname()
  
  return useMemo(
    () => pathname.split('/').filter(Boolean),
    [ pathname ],
  )
}
